module.exports = __webpack_public_path__ + "img/picture_noorder.8ee3c3f0.png";